import { Checkbox } from "@/components/ui/checkbox";

const depth = (z) => z.path.split(" / ").length - 1;

export const ZonePicker = ({ zones, value = [], onChange, testid = "zone-picker" }) => {
  const toggle = (id, on) => onChange(on ? [...value, id] : value.filter((x) => x !== id));
  if (!zones.length) return <p className="text-sm text-muted-foreground">No hay zonas configuradas. Créalas en Configuración → Zonas.</p>;
  return (
    <div className="max-h-56 overflow-y-auto rounded-lg border border-border p-2" data-testid={testid}>
      {zones.filter((z) => z.active || value.includes(z.id)).map((z) => (
        <label key={z.id} className="flex items-center gap-2 py-1 text-sm" style={{ paddingLeft: depth(z) * 18 }}>
          <Checkbox checked={value.includes(z.id)} onCheckedChange={(c) => toggle(z.id, !!c)} data-testid={`${testid}-${z.id}`} />
          {z.name}
        </label>
      ))}
    </div>
  );
};
